import { SelectionModel } from "@angular/cdk/collections"
import { DaoBase } from "./daos/dao-base"

export class TrTableSelectionModel extends SelectionModel<string> {
  constructor(dao: DaoBase<any>, initiallySelectedItems: string[] = []) {
    super(true, initiallySelectedItems)
    this.getAllDataItems = dao.getPotentialSelections.bind(dao)
    this.getDataItemById = dao.getDataItemById.bind(dao)
  }

  /**
   * Should not be changed. This is initialized when the dao is passed into the constructor.
   */
  public getAllDataItems: () => any[]
  public getDataItemById: (id: string) => any

  /**
   * Whether the number of selected elements matches the total number of rows.
   */
  public isAllSelected(): boolean {
    const numSelected = this.selected.length
    return numSelected === this.getAllDataItems().length
  }

  public selectById(id: string): void {
    this.select(this.getDataItemById(id))
  }

  public deselectById(id: string): void {
    this.deselect(this.getDataItemById(id))
  }

  public toggleSelectionById(id: string): void {
    this.toggleSelection(id)
  }

  public toggleSelection(id: string): void {
    this.isSelected(id)
      ? this.deselect(id)
      : this.select(id)
  }

  /**
   * Selects all rows if they are not all selected; otherwise clear selection.
   */
  public toggleAllSelections(): void {
    this.isAllSelected()
      ? this.deselectAll()
      : this.selectAll()
  }

  public selectAll(): void {
    this.select(...this.getAllDataItems().map((v: any) => v._id))
  }

  public deselectAll(): void {
    this.clear()
  }
}
